import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'automationTemplate/trigger';

export function useAvailableAutomationTriggersQuery({
	enabled = true,
	impersonationContext,
}: {
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IAvailableAutomationTrigger[]>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: 'automationTemplate/trigger',
					impersonationContext,
				}),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, impersonationContext?.account?.id],
	});
}

export function invalidateAllAvailableAutomationTriggersQueries() {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
}
